import { Component } from '@angular/core';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
declare function CheckoutWebComponents(obj): void;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'checkout-int';
  response: any;
  loading = false;  // sample payload
  payload: any = {
    TransactionID: 250394902,
    PaymentAmount: 286,
    ClientID: 'LzCiRZ1xXu6eyw887fVGHgpH7IpyBd967bwAg31YPnL+LXP0UHtMwd6GbpTYZaBR',
    TUI: 'ONa5c24a37-3f82-42b3-87b1-a0875dc9e913|c81707a7-4b08-4762-9798-a568e53576ca|20250926090837',
    Hold: false,
    Promo: null,
    PaymentType: 'CC',
    BankCode: 'CKT',
    GateWayCode: 'CKT_CC',
    MerchantID: '',
    PaymentCharge: 0,
    Card: {
      Number: '',
      Expiry: '',
      CVV: '',
      CHName: '',
      Address: '',
      City: '',
      State: '',
      Country: '',
      PIN: '',
      International: false,
      SaveCard: false,
      Token: '',
      EMIMonths: '0',
      NumberAlias: ''
    },
    VPA: '',
    VPAId: '',
    CardAlias: '',
    QuickPay: null,
    RMSSignature: '',
    TargetCurrency: '',
    TargetAmount: 0,
    ThirdPartyInfo: {},
    RequestParameters: {
      JavaEnabled: 'true',
      JavascriptEnabled: 'true',
      ScreenHeight: '1080',
      ScreenWidth: '1920',
      ColorDepth: '24',
      Language: 'en-US',
      TimezoneOffset: '-330'
    }
  };

  private apiUrl = 'https://aeb2cbetaapi.akbartravels.com/Payment/StartPay';
  constructor(private http: HttpClient) { 
    this.sendPayment()  
    // console.log(this.sendPayment())
  }

  startPay(payload: any, token: string): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    return this.http.post<any>(this.apiUrl, payload, { headers });
  }
  // ////////////////////////////
  sessionToken = 'sk_tp2f6g4sn4fcnfukmyqjlsdbh4v'
  sessionUrl ='https://api.checkout.com/payment-sessions'
  sessionPayLoad  ={
    "amount": 17800,
    "currency": "AED",
    "reference": "AK250379493",
    "billing": {
      "address": {
        "country": "AE"
      }
    },
    "3ds": {
      "enabled": true
    },
    "customer": {
      "name": "TEST",
      "email": "test@gmail.com",
      "phone": {
        "number": "501234567"
      }
    },
    "payment_method_configuration": {
      "card": {
        "store_payment_details": "enabled"
      }
    },
    "enabled_payment_methods": [
      "card"
    ],
    "ip_address": "122.166.24.15",
    "success_url": "https://aeb2cbetaapi.akbartravels.com/Payment/CommitPay/CheckoutPayment?id=AK250379493",
    "failure_url": "https://aeb2cbetaapi.akbartravels.com/Payment/CommitPay/CheckoutPayment?id=AK250379493"
  }

  paymentSession(payload: any): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.sessionToken}`
    });

    return this.http.post<any>(this.sessionUrl, payload, { headers });
  }

  // put your token here (or get dynamically)
  token: string = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjExMSIsIm5iZiI6MTc1ODg2NDM2NywiZXhwIjoxNzU5NzI4MzY3LCJpYXQiOjE3NTg4NjQzNjcsImlzcyI6IndlYmNvbm5lY3QiLCJhdWQiOiJjbGllbnQifQ.jY2WcGRNuYXq_QJmDpkwNEug9Tjz0wEx7U2Ue1X1DRE';

  sendPayment() {
    this.loading = true;
    this.paymentSession(this.sessionPayLoad).subscribe(
      response => {https://meet.google.com/rbx-hvrm-bng?authuser=1
        console.log('response', response);
        this.checkoutWeb(response);
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.response = error;
      }
    )


    this.response = {
      "TUI": "ONa5c24a37-3f82-42b3-87b1-a0875dc9e913|4c3ca99c-3ecd-41c9-9147-4dd5b3948f33|20250926135726",
      "Code": "6004",
      "Msg": [
        "Payment Inprogress..."
      ],
      "PaymepaymentSessionntID": "181846",
      "TransactionID": 250394902,
      "RedirectMode": "S",
      "PostData": "ewoJImlkIjogInBzXzMzRVNINE1xR1hSbURiVjdZcnNOUUpaZ2V6YyIsCgkicGF5bWVudF9zZXNzaW9uX3NlY3JldCI6ICJwc3NfNDVkY2FhZjAtMTJlNy00ZDExLTg5NGUtY2Y2ZDA3YzI4NmUyIiwKCSJwYXltZW50X3Nlc3Npb25fdG9rZW4iOiAiWW1GelpUWTA6ZXlKcFpDSTZJbkJ6WHpNelJWTklORTF4UjFoU2JVUmlWamRaY25OT1VVcGFaMlY2WXlJc0ltVnVkR2wwZVY5cFpDSTZJbVZ1ZEY4M2RHbzJaWE5qZVdGMWNHbDVOalZ2ZDNKeE5qVnJkalIwYlNJc0ltVjRjR1Z5YVcxbGJuUnpJanA3ZlN3aWNISnZZMlZ6YzJsdVoxOWphR0Z1Ym1Wc1gybGtJam9pY0dOZllYRjVjSFEwYVRVelptUmxhR3BrYTI5alpIWTBObWsyZFhVaUxDSmhiVzkxYm5RaU9qSTROakF3TENKc2IyTmhiR1VpT2lKbGJpMUhRaUlzSW1OMWNuSmxibU41SWpvaVFVVkVJaXdpY0dGNWJXVnVkRjl0WlhSb2IyUnpJanBiZXlKMGVYQmxJam9pWTJGeVpDSXNJbU5oY21SZmMyTm9aVzFsY3lJNld5SldhWE5oSWl3aVRXRnpkR1Z5WTJGeVpDSXNJa0Z0WlhnaVhTd2ljMk5vWlcxbFgyTm9iMmxqWlY5bGJtRmliR1ZrSWpwbVlXeHpaU3dpYzNSdmNtVmZjR0Y1YldWdWRGOWtaWFJoYVd4eklqb2laR2x6WVdKc1pXUWlMQ0ppYVd4c2FXNW5YMkZrWkhKbGMzTWlPbnNpWTI5MWJuUnllU0k2SWtGRkluMTlYU3dpWm1WaGRIVnlaVjltYkdGbmN5STZXeUpoYm1Gc2VYUnBZM05mYjJKelpYSjJZV0pwYkdsMGVWOWxibUZpYkdWa0lpd2lZMkZ5WkY5bWFXVnNaSE5mWlc1aFlteGxaQ0lzSW1kbGRGOTNhWFJvWDNCMVlteHBZMTlyWlhsZlpXNWhZbXhsWkNJc0lteHZaM05mYjJKelpYSjJZV0pwYkdsMGVWOWxibUZpYkdWa0lpd2ljbWx6YTE5cWMxOWxibUZpYkdWa0lpd2lkWE5sWDJWa1oyVmZaMkYwWlhkaGVWOW1ZWE4wYkhsZlpXNWtjRzlwYm5RaUxDSjFjMlZmYm05dVgySnBZMTlwWkdWaGJGOXBiblJsWjNKaGRHbHZiaUpkTENKeWFYTnJJanA3SW1WdVlXSnNaV1FpT21aaGJITmxmU3dpYldWeVkyaGhiblJmYm1GdFpTSTZJa0ZMUWtGU0lGUlNRVlpGVEZNZ1QwNU1TVTVGSUNoR1drVXBJaXdpY0dGNWJXVnVkRjl6WlhOemFXOXVYM05sWTNKbGRDSTZJbkJ6YzE4ME5XUmpZV0ZtTUMweE1tVTNMVFJrTVRFdE9EazBaUzFqWmpaa01EZGpNamcyWlRJaUxDSnBiblJsWjNKaGRHbHZibDlrYjIxaGFXNGlPaUprWlhacFkyVnpMbUZ3YVM1amFHVmphMjkxZEM1amIyMGlmUT09IiwKCSJfbGlua3MiOiB7CgkJInNlbGYiOiB7CgkJCSJocmVmIjogImh0dHBzOi8vYXBpLmNoZWNrb3V0LmNvbS9wYXltZW50LXNlc3Npb25zL3BzXzMzRVNINE1xR1hSbURiVjdZcnNOUUpaZ2V6YyIKCQl9Cgl9Cn0=",
      "CRSPNR": null,
      "BookStatus": null,
      "TUTransactionID": 0,
      "ClientID": "LzCiRZ1xXu6eyw887fVGHgpH7IpyBd967bwAg31YPnL+LXP0UHtMwd6GbpTYZaBR",
      "GatewayCode": "CKT_CC",
      "RedirectUrl": null,
      "ResponseParameters": {
        "ResponseMessage": null
      }
    }
    ;
    let jsonString = atob(this.response.PostData)
    let jsonData = JSON.parse(jsonString)
    console.log('jsonData', jsonData);
    
    // this.checkoutWeb(jsonData);
    this.loading = false;

    
    // this.startPay(this.payload, this.token).subscribe({
    //   next: (res) => {
    //     this.response = res;
    //     let jsonString = atob(this.response.PostData)
    //     let json = JSON.parse(jsonString)
    //     this.checkoutWeb(json);
    //     this.loading = false;
    //   },
    //   error: (err) => {
    //     this.response = err;
    //     this.loading = false;
    //   }
    // });
  }



  // Checkout 
  async checkoutWeb(keys: any) {
    try {
      const paymentSession = keys;
      const checkout: any = await CheckoutWebComponents({
        publicKey:  'pk_lzjcryxegxequrwowokf434kbms',
        environment: "production",
        locale: "en-GB",
        paymentSession,
        appearance,
        onReady: (component) => {
          console.log('ready');
          console.log(
            `onready() -> isValid: "${component.isValid()}" for "${
              component.type
            }"`,
          );
          // this.checkoutLoader = false
        },
        onChange: (component) => { 
          console.log(
            `onChange() -> isValid: "${component.isValid()}" for "${
              component.type
            }"`,
          );
        },
      
        onPaymentCompleted: (_component, paymentResponse) => {
          console.log(
            `onPaymentCompleted() -> isValid: "${_component.isValid()}" for "${
              _component.type
            }"`,
          );
        },
        onCardBinChanged: async (self, cardMetadata) => {
          console.log('cardBinChanged');
        },
      
        handleSubmit: async (self, { session_data }) => {
          console.log('handleSubmit');
        },
        onError: (component, error) => {
          console.log("onError", error, "Component", component.type);
        },
      });
      const flowComponent = checkout.create("flow");
      flowComponent.mount(document.getElementById("flow-container"));
    }
    catch (exception) {
      console.log('exception' , exception)
      
      // this.errorLogger.Log('B2CPORTAL', 'ERROR', 'FLT', "SharedPaymentComponent:checkoutWeb", exception.stack.toLocaleString());
    }

  }


}
const appearance = {
  colorAction: '#d32f2f',
};
